//  import StorageKeys from "../constants/StorageKeys";

export const CurrentLanguage = () => {
  const languageKey = localStorage.getItem("LANGUAGE_KEY") || "vi-VN";
  console.log(languageKey)
  return languageKey;
};

export const CurrentCountry = () => {
  const currentLanguage = CurrentLanguage();
  if ("vi-VN".includes(currentLanguage)) {
    return "vn";
  }
  return "us";
};
